import type { LogFn } from '../log.js';
import { ensureCliSqliteInitialized } from '../sqlite/cli-database.js';
import { startCodeNavCacheInitialization } from '../sqlite/code-nav-cache/code-nav-cache-availability.js';

/** SQLite schema migrations must finish before bridge message handlers attach. */
export async function ensureBridgeConnectionDatabases(log: LogFn): Promise<void> {
  await ensureCliSqliteInitialized({ logLegacyMigration: log });
  void startCodeNavCacheInitialization(log);
}
